import React from 'react';
import useOrganizationMedicalProfiles from '../../../../../../../hooks/api/useOrganizationMedicalProfiles';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';
import MainContentContainer from '../../../../../../v2BaseComponents/MainContentContainer';
import ClientProfilesTable from './ClientProfilesTable';
import { SideDrawerContainer } from '../../../../../../v2BaseComponents/SideDrawer';

export type AgentProfilesRootOwnProps = {};

export type AgentProfilesRootProps = AgentProfilesRootOwnProps;

const AgentProfilesRoot: React.FC<AgentProfilesRootProps> = (_props) => {
    const { isLoadingOrganizationMedicalProfiles } = useOrganizationMedicalProfiles();

    return (
        <SideDrawerContainer>
            <AnimateLoadedContent isLoading={isLoadingOrganizationMedicalProfiles}>
                {() => (
                    <>
                        <MainContentContainer flex={1}>
                            <ClientProfilesTable />
                        </MainContentContainer>
                    </>
                )}
            </AnimateLoadedContent>
        </SideDrawerContainer>
    );
};

export default React.memo(AgentProfilesRoot);
